import type React from 'react';

import classNames from 'classnames';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { StepBackIcon } from '../../icons/step-back';
import { StepForwardIcon } from '../../icons/step-forward';
import { Tooltip } from '../tooltip/tooltip';

import styles from './step-button.module.css';

type Props = {
  className?: string;
  onClick?: () => void;
};

export function StepBackButton({ onClick, className }: Props) {
  const { t } = useTranslation();

  const label = t('ui.step-back.button.label');
  const button = useCallback(
    (ref: React.LegacyRef<HTMLButtonElement>, props: Record<string, unknown>) => (
      <button
        type="button"
        name="step-back-button"
        data-testid="step-back-button"
        className={classNames(className, styles.button)}
        onClick={onClick}
        ref={ref}
        {...props}
      >
        <StepBackIcon />
      </button>
    ),
    [className, onClick]
  );
  return <Tooltip tooltip={label} trigger={button} />;
}

export function StepForwardButton({ onClick }: Props) {
  const { t } = useTranslation();

  const label = t('ui.step-forward.button.label');
  const button = useCallback(
    (ref: React.LegacyRef<HTMLButtonElement>, props: Record<string, unknown>) => (
      <button
        type="button"
        name="step-forward-button"
        data-testid="step-forward-button"
        className={styles.button}
        onClick={onClick}
        ref={ref}
        {...props}
      >
        <StepForwardIcon />
      </button>
    ),
    [onClick]
  );
  return <Tooltip tooltip={label} trigger={button} />;
}
